// extracted by mini-css-extract-plugin
export default {"modal_bg":"ModalFrame_modal_bg__g3Ag3"};